import { createContext, useContext } from "react";

import type { ApiClient } from "./client";

/**
 * Provider は client-provider.tsx に置く（1 ファイルからコンポーネントと
 * 非コンポーネントを両方 export すると Fast Refresh が効かない）。
 */
export const ApiClientContext = createContext<ApiClient | null>(null);

export function useApiClient(): ApiClient {
  const client = useContext(ApiClientContext);
  if (client === null) {
    throw new Error(
      "useApiClient は ApiClientProvider の配下で使用してください",
    );
  }
  return client;
}
